export function AppSplash({ leaving = false }: { leaving?: boolean }) {
	return (
		<div
			className="app-splash"
			data-state={leaving ? 'leaving' : 'loading'}
			role="status"
			aria-live="polite"
			aria-label="Đang tải ứng dụng"
		>
			<div className="app-splash-content">
				<img
					className="app-splash-logo"
					src="/images/logo.png"
					alt="Samtek"
					width={585}
					height={170}
					loading="eager"
					fetchPriority="high"
				/>
				<div className="app-splash-track" aria-hidden="true">
					<span />
				</div>
				<p>Đang tải...</p>
			</div>
		</div>
	);
}
